import { Component, AfterViewInit } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { DocumentPickerComponent } from '../../../shared/document-picker/document-picker.component';

@Component({
    selector: 'app-guides',
    imports: [
    MatButtonModule,
    MatCheckboxModule,
    MatInputModule,
    MatRadioModule,
    MatFormFieldModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatToolbarModule,
    RouterModule,
    MatIconModule,
    MatTabsModule,
    DocumentPickerComponent
],
    templateUrl: './guides.component.html',
    styleUrl: './guides.component.css'
})
export class GuidesComponent implements AfterViewInit{

  ngAfterViewInit() {
    setTimeout(() => this.slightScrollOnLoad(), 200);
 }

 private slightScrollOnLoad() {
  window.scrollBy({ top: 180, left: 0, behavior: 'smooth' });
}

  onTabChange(event: any) {}


}
